import React from 'react';
import { useTranslation } from 'react-i18next';
import Modal from 'components/Modal';
import Card from 'components/Card';
import ModalHeadline from 'components/ModalHeadline';
import Panel from 'components/Panel';
import Stack from 'components/Stack';
import Text from 'components/Text';
import Button from 'components/Button';
import BulletList from 'components/BulletList';
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
function CircularReferenceInfoModal(_ref) {
  var circularPlaylists = _ref.circularPlaylists,
    onCloseModal = _ref.onCloseModal,
    onSubmit = _ref.onSubmit;
  var _useTranslation = useTranslation(),
    t = _useTranslation.t;
  var titleId = 'circular-reference-info-title';
  return /*#__PURE__*/_jsx(Modal, {
    id: "circular-reference-info",
    "aria-labelledby": titleId,
    onRequestClose: function onRequestClose() {
      return onCloseModal();
    },
    children: /*#__PURE__*/_jsxs(Card, {
      variant: "raised",
      px: "xs",
      children: [/*#__PURE__*/_jsx(ModalHeadline, {
        title: t('modal_circular_reference_title'),
        titleId: titleId,
        onClose: function onClose() {
          return onCloseModal();
        }
      }), /*#__PURE__*/_jsx(Panel, {
        children: /*#__PURE__*/_jsxs(Stack, {
          spacing: "m",
          children: [/*#__PURE__*/_jsx(Text, {
            as: "p",
            children: t('modal_circular_reference_intro')
          }), /*#__PURE__*/_jsx(BulletList, {
            children: circularPlaylists
          }), /*#__PURE__*/_jsx(Text, {
            as: "p",
            children: t('modal_circular_reference_outro')
          })]
        })
      }), /*#__PURE__*/_jsx(Panel, {
        align: "center",
        children: /*#__PURE__*/_jsx(Button, {
          onClick: function onClick() {
            return onSubmit();
          },
          children: t('actions_ok')
        })
      })]
    })
  });
}
export default CircularReferenceInfoModal;